import { Component, EventEmitter, Input, Output} from '@angular/core';
import { MessageService } from 'primeng/api';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {
  PlantingsImportService,
  PlantingsImportSourceType
} from '@6grain/masofa-monolith-api-client/crop-monitoring';
import {Dialog} from 'primeng/dialog';
import {FileUploadComponent} from '@components/file-upload/file-upload.component';
import {PrimaryButton} from '@components/button/primary-button/primary-button';
import {SecondaryButton} from '@components/button/secondary-button/secondary-button';
import {TextareaComponent} from '@components/textarea';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-import-field-modal',
  templateUrl: './import-field-modal.html',
  imports: [
    Dialog,
    TranslatePipe,
    FileUploadComponent,
    PrimaryButton,
    SecondaryButton,
    TextareaComponent,
    FormsModule,
  ],
  styleUrls: ['./import-field-modal.scss']
})
export class ImportFieldModalComponent {

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() importSuccess = new EventEmitter<void>();

  formData = {
    comment: ''
  };

  selectedImportFiles: File[] = [];
  isImporting: boolean = false;

  constructor(
    private messageService: MessageService,
    private translate: TranslateService,
    private plantingsImportService: PlantingsImportService
  ) {

  }

  onFileSelected(files: File[]): void {
    if (!files || files.length === 0) {
      return;
    }

    for (const file of files) {
      const fileName = (file.name || '').toLowerCase();

      if (!fileName.endsWith('.shp') && !fileName.endsWith('.zip') &&
        !fileName.endsWith('.kml') && !fileName.endsWith('.geojson')) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('ERROR'),
          detail: this.translate.instant('Error_Unsupported_import_fields')
        });
        continue; // skip invalid file but continue processing others
      }

      // Avoid duplicates by name+size
      const exists = this.selectedImportFiles.some(f => f.name === file.name && f.size === file.size);
      if (!exists) {
        this.selectedImportFiles.push(file);
      }
    }
  }

  closeImportModal(): void {
    this.visible = false;
    this.selectedImportFiles = [];
    this.isImporting = false;
    this.visibleChange.emit(this.visible);
  }

  performImport(): void {
    console.log(this.formData);
    console.log(this.selectedImportFiles);

    if (!this.selectedImportFiles || this.selectedImportFiles.length === 0 || this.isImporting) {
      return;
    }

    this.isImporting = true;

    // Унифицированный импорт: стейджинг файлов в ImportedFieldReport (SourceType=ImportedField, stageOnly=true).
    this.plantingsImportService.cropMonitoringPlantingsImportImportPost(
      PlantingsImportSourceType.NUMBER_6,
      this.selectedImportFiles,
      undefined,
      undefined,
      undefined,
      undefined,
      true,
      this.formData.comment
    ).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('SUCCESS'),
          detail: this.translate.instant('IMPORT_SUCCESS') || 'Import successful'
        });
        this.importSuccess.emit();
        this.closeImportModal();
      },
      error: (error: any) => {
        this.isImporting = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('ERROR'),
          detail: this.translate.instant('IMPORT_FAILED') || 'Import failed. Please try again.'
        });
        console.error('Import error:', error);
      }
    });

  }

  onFileRemoved(event: any) {
    // support both index (number) or File object
    if (typeof event === 'number') {
      this.selectedImportFiles.splice(event, 1);
      return;
    }

    if (event && event.name) {
      const idx = this.selectedImportFiles.findIndex(f => f.name === event.name && f.size === event.size);
      if (idx >= 0) {
        this.selectedImportFiles.splice(idx, 1);
      }
    }
  }


}
